import Classnames from 'classnames'
import { useRecoilState, useRecoilValue, useRecoilCallback } from 'recoil'
import {
  isBuilder,
  screen,
  screenOpen,
  editSectionId,
  editSectionWrapperId,
} from '@/store/builder/store'
import { RiSettings5Line } from 'react-icons/ri'
import * as RemixIcon from 'react-icons/ri'
import { section } from '@/store/template/section'

function HeadlineSection({ id, contentID, sectionData, wrapperId }) {
  const isBuilderApp = useRecoilValue(isBuilder)
  const [getSreen, setScreen] = useRecoilState(screen)
  const [getScreenOpen, setScreenOpen] = useRecoilState(screenOpen)
  const [getEditSectionId, setEditSectionId] = useRecoilState(editSectionId)
  const [getEditSectionWrapperId, setEditSectionWrapperId] =
    useRecoilState(editSectionWrapperId)
  const [getSection, setSection] = useRecoilState(section(id))

  let IconComponent = RemixIcon['RiFileEditLine']

  if (getSection.icon !== 'noicon') {
    IconComponent = RemixIcon[getSection.icon]
  }

  return (
    <div
      className={Classnames(
        'boxHeadline bg-no-repeat relative  w-full h-full overflow-hidden flex flex-col justify-center',
        {
          'items-center': sectionData.data.align == 'center',
          'text-center': sectionData.data.align == 'center',
          'items-end': sectionData.data.align == 'right',
          'text-right': sectionData.data.align == 'right',
        }
      )}
      style={{
        marginTop: sectionData.data.vert_padding
          ? sectionData.data.vert_padding + '%'
          : '0%',
        marginBottom: sectionData.data.vert_padding
          ? sectionData.data.vert_padding + '%'
          : '0%',
      }}
    >
      {/* edit icon */}
      {isBuilderApp && (
        <div
          onClick={() => {
            setScreen('editsection')
            setScreenOpen(true)
            setEditSectionId(id)
            setEditSectionWrapperId(wrapperId)
          }}
          className="absolute top-2 right-3 opacity-50 hover:opacity-100 hover:shadow p-1 text-lg rounded  hover:bg-blue-500 hover:text-white cursor-pointer"
        >
          <RiSettings5Line />
        </div>
      )}
      <div
        className={Classnames('flex items-center justify-between', {
          'flex-row-reverse':
            getSection.icon !== 'noicon' && getSection.iconalign == 'right',
        })}
      >
        {/* OPTIONAL ICON */}
        {getSection.icon !== 'noicon' && (
          <div
            className={Classnames(
              'sectionIcon h-16 w-16 flex-shrink-0 text-4xl flex items-center justify-center',
              {
                'mr-4': getSection.iconalign == 'left',
                'ml-4': getSection.iconalign == 'right',
                rounded: getSection.iconstyle == 'square',
                'rounded-full': getSection.iconstyle == 'circle',
                ' bg-gray-100 text-gray-600': getSection.iconcolor == 'gray',
                ' bg-blue-100 text-blue-500': getSection.iconcolor == 'blue',
                ' bg-green-100 text-green-600': getSection.iconcolor == 'green',
                ' bg-red-100 text-red-600': getSection.iconcolor == 'red',
                ' bg-purple-100 text-purple-600':
                  getSection.iconcolor == 'purple',
                ' bg-pink-100 text-pink-600': getSection.iconcolor == 'pink',
                ' bg-indigo-100 text-indigo-600':
                  getSection.iconcolor == 'indigo',
                ' bg-yellow-100 text-yellow-600':
                  getSection.iconcolor == 'yellow',
                ' bg-gray-600 text-gray-50': getSection.iconcolor == 'darkgray',
                ' bg-green-500 text-green-50':
                  getSection.iconcolor == 'darkgreen',
                ' bg-blue-500 text-blue-50': getSection.iconcolor == 'darkblue',
                ' bg-red-500 text-red-50': getSection.iconcolor == 'darkred',
                ' bg-purple-500 text-purple-50':
                  getSection.iconcolor == 'darkpurple',
                ' bg-pink-500 text-pink-50': getSection.iconcolor == 'darkpink',
                ' bg-indigo-500 text-indigo-50':
                  getSection.iconcolor == 'darkindigo',
                ' bg-yellow-400 text-yellow-50':
                  getSection.iconcolor == 'darkyellow',

                ' text-gray-700':
                  getSection.iconcolor == 'darkgray' &&
                  getSection.iconstyle == 'icononly',
                ' text-green-700':
                  getSection.iconcolor == 'darkgreen' &&
                  getSection.iconstyle == 'icononly',
                ' text-blue-700':
                  getSection.iconcolor == 'darkblue' &&
                  getSection.iconstyle == 'icononly',
                ' text-red-700':
                  getSection.iconcolor == 'darkred' &&
                  getSection.iconstyle == 'icononly',
                ' text-purple-700':
                  getSection.iconcolor == 'darkpurple' &&
                  getSection.iconstyle == 'icononly',
                ' text-pink-700':
                  getSection.iconcolor == 'darkpink' &&
                  getSection.iconstyle == 'icononly',
                ' text-indigo-700':
                  getSection.iconcolor == 'darkindigo' &&
                  getSection.iconstyle == 'icononly',
                ' text-yellow-700':
                  getSection.iconcolor == 'darkyellow' &&
                  getSection.iconstyle == 'icononly',
                sectionIconNoBG: getSection.iconstyle == 'icononly',
              }
            )}
          >
            <IconComponent />
          </div>
        )}
        <h1
          className="textCalloutHeadline flex-grow  font-bold leading-tight"
          style={{
            fontSize: sectionData.data.headline_size
              ? sectionData.data.headline_size + 'px'
              : '36px',
            lineHeight: sectionData.data.headline_lineheight
              ? sectionData.data.headline_lineheight + 'px'
              : 'auto',
            marginLeft: sectionData.data.side_padding
              ? sectionData.data.side_padding + '%'
              : '0%',
            marginRight: sectionData.data.side_padding
              ? sectionData.data.side_padding + '%'
              : '0%',
          }}
        >
          {sectionData.title}
        </h1>
      </div>

      {sectionData.prompt && (
        <h3
          className="textCalloutSubHeadline mt-0 "
          style={{
            fontSize: sectionData.data.subtitle_size
              ? sectionData.data.subtitle_size + 'px'
              : '18px',
            lineHeight: sectionData.data.subtitle_lineheight
              ? sectionData.data.subtitle_lineheight + 'px'
              : 'auto',
            marginLeft: sectionData.data.subtitle_side_padding
              ? sectionData.data.subtitle_side_padding + '%'
              : '0%',
            marginRight: sectionData.data.subtitle_side_padding
              ? sectionData.data.subtitle_side_padding + '%'
              : '0%',
          }}
        >
          {sectionData.prompt}
        </h3>
      )}
    </div>
  )
}

export default HeadlineSection
